import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'


const Styles = styled.div `

`

export default class Reads extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    render () {
        return(
            <Styles>
                <div>
                    <h1>Reads</h1>
                </div>
            </Styles>
        )
    }
}